import React, { useState } from "react";
import {
  Box,
  Typography,
  Container,
  useMediaQuery,
  Divider,
  Grid,
} from "@mui/material";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { projectbannerbg } from "../../../../../assets";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Layout } from "../ProjectInterface";

interface LayoutProps {
  layout: Layout | null;
}

const CDN_URL = process.env.NEXT_PUBLIC_STORAGE_DN_URL || 'https://dprstorage.b-cdn.net';
const resolveImageUrl = (path: string) => {
  if (!path) return '';
  return path.startsWith('http') ? path : `${CDN_URL}${path}`;
};

const MasterLayout: React.FC<LayoutProps> = ({ layout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const isMobile = useMediaQuery("md");

  const isValid = layout && layout.img && layout.highlights;

  const images: string[] = isValid ? [resolveImageUrl(layout.img)] : [];

  return (
    <Box sx={{ width: "100%", overflow: "hidden", position: "relative" }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "auto",
          backgroundImage: `url(${projectbannerbg})`,
          backgroundSize: "cover",
          backgroundPosition: "bottom center",
          backgroundRepeat: "no-repeat",
          "&:after": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.6)",
            zIndex: 1,
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            zIndex: 2,
            pt: { xs: 4, md: 4 },
            py: 4,
          }}
        >
          <Container maxWidth="xl">
            <Box sx={{ textAlign: "center", color: "white", mb: 2}}>
              <Typography variant="h4" fontWeight={600} sx={{ mt: 4, color: 'white', mb: 1 ,fontFamily: 'Futura,  sans-serif !important',
            letterSpacing:"2px"}}>
                MASTER LAYOUT
              </Typography>
              <Box
                sx={{
                  width: {
                    xs: "120px",
                    md: "180px",
                  },

                  height: "2px",

                  background:
                    "linear-gradient(to right, transparent, #fff, transparent)",

                  mx: "auto",

                  mb: 3,
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  fontSize: isMobile ? "13px" : "16px",
                  maxWidth: "800px",
                  mx: "auto",
                  fontWeight: 300,
                  letterSpacing: 1,
                  color: "#ffffff",
                  opacity: 0.9,
                }}
              >
                {isValid ? layout.d1 : "Layout data is not uploaded."}
              </Typography>
            </Box>

            {isValid && (
              <Grid
                container
                spacing={4}
                sx={{ justifyContent: "center", alignItems: "center" }}
              >
                <Grid item xs={12} md={7} sx={{ display: "flex", justifyContent: "center" }}>
                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: 600,
                      borderRadius: 2,
                      overflow: "hidden",
                      cursor: "pointer",
                    }}
                    onClick={() => setIsOpen(true)}
                  >
                    {/* <img
                      src={resolveImageUrl(layout.img)}
                      alt="Master Layout"
                      style={{
                        width: "100%",
                        height: "auto",
                        borderRadius: 8,
                      }}
                    /> */}
                    <Box
                                        component="img"
                                        src={resolveImageUrl(layout.img)}
                                        alt="Master Layout"
                                        sx={{
                                            width: "100%",
                                            height: "400px",
                                            borderRadius: 8,

                                            //   display: "block",

                                            transition: "0.4s",

                                            "&:hover": {
                                                transform: "scale(1.03)",
                                            },
                                        }}
                                    />
                  </Box>
                </Grid>

                <Grid item xs={12} md={5}>
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    {layout.highlights.map((feature, index) => (
                      <Box key={index} sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                        <FiberManualRecordIcon sx={{ color: "white", mr: 1, fontSize: "10px" }} />
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: "16px",
                            fontWeight: 400,
                            color: "#ffffff",
                            letterSpacing: 1,
                            textAlign: 'start',
                          }}
                        >
                          {feature}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Grid>
              </Grid>
            )}

            {/* Lightbox */}
            {isOpen && images.length > 0 && (
              <Lightbox
                mainSrc={images[photoIndex]}
                nextSrc={images[(photoIndex + 1) % images.length]}
                prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                onCloseRequest={() => setIsOpen(false)}
                onMovePrevRequest={() =>
                  setPhotoIndex((photoIndex + images.length - 1) % images.length)
                }
                onMoveNextRequest={() =>
                  setPhotoIndex((photoIndex + 1) % images.length)
                }
              />
            )}
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default MasterLayout;
